export const REPORT_TYPES = ['MOMENT', 'EXPLORE', 'PROFILE', 'COMMENT', 'MESSAGE', 'QUEST'];

export function reportCopy(language) {
  return String(language).toLowerCase().startsWith('fr') ? {
    more: 'Plus d’options', report: 'Signaler', close: 'Fermer',
    success: 'Ton signalement sera examiné.',
    unavailable: 'Impossible d’envoyer le signalement. Réessaie dans un instant.',
    auth: 'Connecte-toi pour signaler ce contenu.',
    missing: 'Ce contenu n’est plus accessible. Le signalement n’a pas été envoyé.',
    changed: 'Ce contenu a été modifié. Réessaie de le signaler.',
    limited: 'Trop de signalements rapprochés. Réessaie dans dix minutes.',
  } : {
    more: 'More options', report: 'Report', close: 'Close',
    success: 'Your report will be reviewed.',
    unavailable: 'Unable to send your report. Please try again shortly.',
    auth: 'Sign in to report this content.',
    missing: 'This content is no longer accessible. Your report was not sent.',
    changed: 'This content has changed. Please try reporting it again.',
    limited: 'Too many reports. Please try again in ten minutes.',
  };
}

export function reportErrorMessage(error, copy) {
  if (error?.status === 401) return copy.auth;
  if (error?.status === 429) return copy.limited;
  if (error?.code === 'report_target_unavailable') return copy.missing;
  if (error?.code === 'report_target_changed') return copy.changed;
  return copy.unavailable;
}

export function reportQuery(coordinates) {
  const { latitude, longitude } = coordinates || {};
  if (typeof latitude !== 'number' || typeof longitude !== 'number'
    || !Number.isFinite(latitude) || !Number.isFinite(longitude)
    || Math.abs(latitude) > 90 || Math.abs(longitude) > 180) return '';
  return `?latitude=${encodeURIComponent(latitude)}&longitude=${encodeURIComponent(longitude)}`;
}

// Keep a retry's key after network errors, including after a menu unmounts.
// Accepted targets are deduplicated for this signed-in frontend session only.
export function createReportClient(randomUUID) {
  const attempts = new Map();
  return {
    submit(target, send) {
      if (!REPORT_TYPES.includes(target.targetType) || !String(target.targetId || '').trim()) {
        return Promise.reject(new Error('invalid_report_target'));
      }
      const id = `${target.targetType}:${target.targetId}`;
      let attempt = attempts.get(id);
      if (attempt?.promise) return attempt.promise;
      if (!attempt) {
        if (attempts.size >= 256) {
          const removable = [...attempts].find(([, value]) => !value.pending);
          if (!removable) return Promise.reject(new Error('report_unavailable'));
          attempts.delete(removable[0]);
        }
        attempt = { key: randomUUID(), pending: false, promise: null };
        attempts.set(id, attempt);
      }
      attempt.pending = true;
      const current = attempt;
      current.promise = Promise.resolve().then(() => send({
        targetType: target.targetType, targetId: String(target.targetId),
      }, current.key)).then(result => {
        if (typeof result?.reference !== 'string' || !/^[0-9a-f]{8}(-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(result.reference)) {
          throw new Error('invalid_report_response');
        }
        current.pending = false;
        return result;
      }).catch(error => {
        current.pending = false;
        current.promise = null;
        throw error;
      });
      return current.promise;
    },
  };
}
